/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */

import Column3DDataset from './column3d';
import { drawLabel } from './bar2d';
import { addDep } from '../dependency-manager';
import bar3DAnimation from '../animation-rules/bar3d-animation';
addDep({
  name: 'bar3DAnimation',
  type: 'animationRule',
  extension: bar3DAnimation
});
/**
 * representing bar3d dataset
 */
class Bar3DDataset extends Column3DDataset {
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'bar3D';
  }
  /**
   * Helper function of _getHoveredPlot().
   * @param {number} pX index of column
   * @param {number} chartX x co-ordinate
   * @param {number} chartY y co-ordinate
   * @return {Object}        hovered information
   */
  _checkPointerOverColumn (pX, chartX, chartY) {
    var dataset = this,
      chart = dataset.getFromEnv('chart'),
      chartConfig = chart.config,
      plotBorderThickness = chartConfig.plotborderthickness,
      showPlotBorder = chartConfig.showplotborder,
      dataStore = dataset.components.data,
      pointObj = dataStore[pX],
      pY,
      dx,
      dy,
      hovered,
      zDepth = 5,
      xPos,
      yPos,
      width,
      height;

    if (!pointObj) {
      return;
    }

    pY = pointObj.config.setValue;

    // if (chartConfig.isstacked && ((pY < 0 && dataset.valueLook) || (pY > 0 && !dataset.valueLook))) {
    //   return;
    // }

    plotBorderThickness = showPlotBorder ? plotBorderThickness : 0;

    if (pY !== null) {
      yPos = pointObj._yPos;
      height = pointObj._height + zDepth;
      xPos = pointObj._xPos - zDepth;
      width = pointObj._width + zDepth;
      dx = chartX - xPos;
      dy = chartY - yPos;
      hovered = dx >= 0 && dx <= width + plotBorderThickness && dy >= 0 && dy <= height + plotBorderThickness;
      if (pY >= 0) {
        hovered = hovered ? (chartX + chartY - (xPos + yPos) - zDepth) > 0 : false;
        hovered = hovered ? (chartX + chartY - (xPos + yPos + width + height) + zDepth) < 0 : false;
      } else {
        hovered = hovered ? (chartX + chartY - (xPos + yPos) - (zDepth)) > 0 : false;
        hovered = hovered ? (chartX + chartY - (xPos + yPos + width + height) + (zDepth)) < 0 : false;
      }
      if (hovered) {
        return {
          pointIndex: pX,
          hovered: hovered,
          pointObj: dataStore[pX]
        };
      }
    }
  }
  /**
   * Function that return the nearest plot details
   * @param {number} chartX x-axis position of the mouse cordinate
   * @param {number} chartY x-axis position of the mouse cordinate
   * @return {Object} return an object with details of nearest polt and whether it is hovered or not
   */
  _getHoveredPlot (chartX, chartY) {
    var dataset = this,
      chart = dataset.getFromEnv('chart'),
      isBar = chart.isBar,
      xAxis = dataset.getFromEnv('xAxis'),
      x,
      pX;
    x = xAxis.getValue(isBar ? chartY : chartX);
    pX = Math.round(x);
    // Checking for overlap between two cosecutive column plots along x-axis
    return (pX - x > 0 ? dataset._checkPointerOverColumn(pX, chartX, chartY) ||
                  dataset._checkPointerOverColumn(pX - 1, chartX, chartY) :
      dataset._checkPointerOverColumn(pX + 1, chartX, chartY) ||
                          dataset._checkPointerOverColumn(pX, chartX, chartY));
  }
  /**
   * Function to draw label for every data plot.
   * It calculates where to draw the label for data plot.
   */
  drawLabel () {
    drawLabel.call(this);
  }
}

export default Bar3DDataset;
